// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"187":"NotFound","397":"Blog","843":"ProjectYIP","877":"Projects","994":"ProjectDetails"}[chunkId] + "." + {"187":"42af5d2d","397":"299e510a","843":"467058ba","877":"b928a488","994":"49034cfa"}[chunkId] + ".css";
};